import { apiAuth } from ".";

export interface LeadStep {
  id: number;
  uuid: string;
  name: string;
  color: string;
  order: number;
  created_at?: string;
  updated_at?: string;
  tenant_id?: number;
}

interface ApiResponse<T> {
  status: boolean;
  response: T;
  message: string;
}

interface CreateLeadStepRequest {
  name: string;
  color: string;
}

interface UpdateLeadStepRequest {
  name: string;
  color: string;
}

interface ReorderLeadStepRequest {
  id: number;
  order: number;
}

export async function createLeadStep(data: CreateLeadStepRequest): Promise<ApiResponse<LeadStep>> {
  try {
    const response = await apiAuth.post("/lead-steps/store", data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao criar etapa do lead");
  }
}

export async function updateLeadStep(uuid: string, data: UpdateLeadStepRequest): Promise<ApiResponse<LeadStep>> {
  try {
    const response = await apiAuth.put(`/lead-steps/${uuid}/update`, data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao atualizar etapa do lead");
  }
}

export async function deleteLeadStep(uuid: string): Promise<ApiResponse<void>> {
  try {
    const response = await apiAuth.delete(`/lead-steps/${uuid}/destroy`);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao excluir etapa do lead");
  }
}

export async function reorderLeadSteps(data: ReorderLeadStepRequest[]): Promise<ApiResponse<LeadStep[]>> {
  try {
    const response = await apiAuth.put("/lead-steps/reorder", data);
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao reordenar etapas do lead");
  }
}

export async function getLeadSteps(): Promise<ApiResponse<LeadStep[]>> {
  try {
    const response = await apiAuth.get("/lead-steps");
    return response.data;
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Erro ao buscar etapas do lead");
  }
} 